import React,{useEffect,useRef} from "react";
import { gsap } from "gsap";

const testimonialsData = [
  {
    title: "Brilliant machines to rent",
    text: "All eFounders teams have moved to Cycle for all things product management and it is truly a game-changer.",
    name: "Jane Cooper",
    position: "CEO at ABC Corporation",
    image: "https://randomuser.me/api/portraits/women/54.jpg",
    colSpan: 2,
  },
  {
    title: "Efficient customer support",
    text: "The customer support team at our service is incredibly responsive and helpful. They went above and beyond to assist me with my issue.",
    name: "Emily Smith",
    position: "Marketing Manager at ABC Company",
    image: "https://randomuser.me/api/portraits/women/30.jpg",
    colSpan: 3,
  },
  {
    title: "Seamless integration process",
    text: "Integrating our systems with our service was smooth and hassle-free. The support team guided us through every step of the process.",
    name: "Sarah Brown",
    position: "CTO at XYZ Corporation",
    image: "https://randomuser.me/api/portraits/women/90.jpg",
    colSpan: 3,
  },
  {
    title: "Reliable service uptime",
    text: "Our service has consistently maintained high uptime, ensuring that our operations run smoothly without any disruptions.",
    name: "James White",
    position: "COO at XYZ Corporation",
    image: "https://randomuser.me/api/portraits/men/90.jpg",
    colSpan: 2,
  },
  {
    title: "Reliable service uptime",
    text: "Our service has consistently maintained high uptime, ensuring that our operations run smoothly without any disruptions.",
    name: "James White",
    position: "COO at XYZ Corporation",
    image: "https://randomuser.me/api/portraits/men/90.jpg",
    colSpan: 2,
  },
];

const Testimonials = () => {


  const testimonialsRef = useRef();


  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        testimonialsRef.current,
        { xPercent: 0 },
        {
          xPercent: -100,
          duration: 20,
          repeat: -1,
          ease: "linear",
        }
      );
    }, testimonialsRef);

    return () => ctx.revert(); // Cleanup GSAP animation on component unmount
  }, []);

  return (
    <>
    <div className="pl-10 font-[sans-serif] mt-4 overflow-x-hidden">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-6 max-lg:max-w-2xl">
            <div className="col-span-2">
          
            </div>
          </div>

          <div
            ref={testimonialsRef}
            className="flex gap-6 mt-16 p-5 space-x-6"
          >
            {testimonialsData.map((testimonial, index) => (
              <div
                key={index}
                className="max-w-[360px] h-auto py-5 pl-14 pr-4 bg-white border-2 rounded-3xl relative flex-shrink-0"
              >
                <img
                  src={testimonial.image}
                  alt={`${testimonial.name}'s profile`}
                  className="w-20 h-20 rounded-full absolute -left-10 top-0 bottom-0 my-auto border-2 border-gray-300"
                />

                <div>
                  <h4 className="text-gray-800 text-base font-bold">
                    {testimonial.name}
                  </h4>
                  <p className="mt-1 text-xs text-gray-500">
                    {testimonial.position}
                  </p>
                </div>

                <div className="mt-4">
                  <p className="text-gray-800 text-sm leading-relaxed">
                    {testimonial.text}
                  </p>
                </div>

                <div className="flex space-x-1 mt-4">
                  {[...Array(5)].map((_, starIndex) => (
                    <svg
                      key={starIndex}
                      className={`w-4 ${
                        starIndex < 4 ? "fill-blue-600" : "fill-gray-300"
                      }`}
                      viewBox="0 0 14 13"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7 0L9.4687 3.60213L13.6574 4.83688L10.9944 8.29787L11.1145 12.6631L7 11.2L2.8855 12.6631L3.00556 8.29787L0.342604 4.83688L4.5313 3.60213L7 0Z" />
                    </svg>
                  ))}
                </div>
              </div>
            ))}
            {/* Repeat testimonials to create an infinite loop */}
            {testimonialsData.map((testimonial, index) => (
              <div
                key={`duplicate-${index}`}
                className="max-w-[360px] h-auto py-5 pl-14 pr-4 bg-white border-2 rounded-3xl relative flex-shrink-0"
              >
                <img
                  src={testimonial.image}
                  alt={`${testimonial.name}'s profile`}
                  className="w-20 h-20 rounded-full absolute -left-10 top-0 bottom-0 my-auto border-2 border-gray-300"
                />

                <div>
                  <h4 className="text-gray-800 text-base font-bold">
                    {testimonial.name}
                  </h4>
                  <p className="mt-1 text-xs text-gray-500">
                    {testimonial.position}
                  </p>
                </div>

                <div className="mt-4">
                  <p className="text-gray-800 text-sm leading-relaxed">
                    {testimonial.text}
                  </p>
                </div>

                <div className="flex space-x-1 mt-4">
                  {[...Array(5)].map((_, starIndex) => (
                    <svg
                      key={starIndex}
                      className={`w-4 ${
                        starIndex < 4 ? "fill-blue-600" : "fill-gray-300"
                      }`}
                      viewBox="0 0 14 13"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7 0L9.4687 3.60213L13.6574 4.83688L10.9944 8.29787L11.1145 12.6631L7 11.2L2.8855 12.6631L3.00556 8.29787L0.342604 4.83688L4.5313 3.60213L7 0Z" />
                    </svg>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
